/* Brightfit theme JS — no dependencies */
(function () {
  'use strict';

  var theme = window.theme || { routes: {} };
  var routes = theme.routes;

  /* Helpers -------------------------------------------------------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  /* Announcement rotator -------------------------------------------------- */
  $$('[data-announcement]').forEach(function (track) {
    var items = $$('.announcement__item', track);
    if (items.length < 2) return;
    var i = 0;
    var interval = parseInt(track.dataset.interval, 10) || 5000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  });

  /* Mobile nav / search: close on outside click & Escape ------------------ */
  document.addEventListener('click', function (e) {
    $$('[data-mobile-nav][open], [data-header-search][open], [data-facet][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('details[open]').forEach(function (d) {
      if (d.matches('[data-mobile-nav], [data-header-search], [data-facet]')) d.removeAttribute('open');
    });
    closeDrawer();
  });
  $$('[data-header-search]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) { var input = $('input[type="search"]', d); if (input) input.focus(); }
    });
  });
  $$('[data-mobile-nav]').forEach(function (d) {
    d.addEventListener('toggle', function () { document.body.classList.toggle('drawer-open', d.open); });
  });

  /* Quantity steppers (delegated) ----------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = $('input', wrap);
    var min = parseInt(input.min, 10) || 0;
    var val = parseInt(input.value, 10) || 0;
    val = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart drawer ----------------------------------------------------------- */
  var drawer = $('[data-cart-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var panel = $('.drawer__panel', drawer);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocus) lastFocus.focus();
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  function refreshCart() {
    var sections = [];
    if (drawer) sections.push('cart-drawer');
    var cartPage = $('[data-cart-page]');
    var mainCartSection = cartPage ? cartPage.closest('.shopify-section') : null;
    var mainCartId = mainCartSection ? mainCartSection.id.replace('shopify-section-', '') : null;
    if (mainCartId) sections.push(mainCartId);

    var jobs = [fetchJSON(routes.cart + '.js').then(function (cart) { updateCount(cart.item_count); return cart; })];
    if (sections.length) {
      jobs.push(fetch(routes.root + '?sections=' + sections.join(',')).then(function (r) { return r.json(); }).then(function (html) {
        var parser = new DOMParser();
        if (drawer && html['cart-drawer']) {
          var doc = parser.parseFromString(html['cart-drawer'], 'text/html');
          var fresh = $('[data-cart-drawer-inner]', doc);
          var current = $('[data-cart-drawer-inner]', drawer);
          if (fresh && current) current.replaceWith(fresh);
        }
        if (mainCartId && html[mainCartId]) {
          var doc2 = parser.parseFromString(html[mainCartId], 'text/html');
          var fresh2 = $('[data-cart-page]', doc2);
          if (fresh2) cartPage.replaceWith(fresh2);
        }
      }));
    }
    return Promise.all(jobs);
  }

  function changeLine(line, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-updating');
    return fetchJSON(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(refreshCart).catch(function (err) {
      if (lineEl) lineEl.classList.remove('is-updating');
      window.alert((err && (err.description || err.message)) || 'Could not update cart');
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }

    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && drawer && theme.cartType === 'drawer') { e.preventDefault(); openDrawer(); return; }

    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(parseInt(remove.dataset.lineRemove, 10), 0, remove.closest('.cart-line'));
    }
  });

  var qtyTimer;
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      changeLine(parseInt(input.dataset.lineQty, 10), Math.max(0, parseInt(input.value, 10) || 0), input.closest('.cart-line'));
    }, 350);
  });

  /* Add to cart (AJAX) ---------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (theme.cartType !== 'drawer' || !drawer) return; // fall back to normal submit -> cart page
    e.preventDefault();

    var btn = $('button[name="add"]', form);
    var errorEl = $('[data-form-error]', form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (errorEl) errorEl.hidden = true;

    var formData = new FormData(form);
    // Include inputs associated via the form="" attribute (e.g. quantity outside the form)
    if (form.id) {
      $$('[form="' + form.id + '"]').forEach(function (el) {
        if (el.name && el.type !== 'radio') formData.set(el.name, el.value);
      });
    }

    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw d; return d; }); })
      .then(refreshCart)
      .then(openDrawer)
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      });
  });

  /* Product page: variant picker + gallery -------------------------------- */
  $$('[data-product]').forEach(function (root) {
    var picker = $('[data-variant-picker]', root);
    var gallery = $('[data-gallery-main]', root);

    function scrollToMedia(id) {
      if (!gallery) return;
      var slide = $('[data-media-id="' + id + '"]', gallery);
      if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
    }

    $$('[data-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () { scrollToMedia(thumb.dataset.thumb); });
    });

    if (gallery) {
      var scrollTimer;
      gallery.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
          var slide = gallery.children[index];
          if (!slide) return;
          $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === slide.dataset.mediaId); });
        }, 80);
      });
    }

    if (!picker) return;
    var variantsEl = $('[data-variants]', picker);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var fieldsets = $$('fieldset[data-option-index]', picker);

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function markAvailability(selected) {
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var candidate = selected.slice();
          candidate[idx] = input.value;
          var available = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === candidate[i]; });
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function update() {
      var selected = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        var lbl = $('[data-selected-label]', fs);
        if (lbl) lbl.textContent = selected[idx] || '';
      });
      markAvailability(selected);

      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });

      var idInput = $('[data-variant-id]', root);
      var btn = $('[data-add-button]', root);
      var btnText = btn ? $('[data-button-text]', btn) : null;
      var priceEl = $('[data-price]', root);

      if (!variant) {
        if (btn) btn.disabled = true;
        if (btnText) btnText.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (btn) btn.disabled = !variant.available;
      if (btnText) btnText.textContent = variant.available ? 'Add to cart' : 'Sold out';

      if (priceEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.classList.toggle('price--sale', !!onSale);
        var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (onSale) html += '<s class="price__compare"><span class="visually-hidden">Regular price</span>' + formatMoney(variant.compare_at_price) + '</s>';
        priceEl.innerHTML = html;
      }

      if (variant.featured_media) scrollToMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('change', update);
    markAvailability(selectedOptions());
  });

  /* Product recommendations ---------------------------------------------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* Collection filters: auto-submit -------------------------------------- */
  $$('[data-filter-form]').forEach(function (form) {
    var timer;
    function submit() {
      var params = new URLSearchParams(new FormData(form));
      // drop empty price inputs
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      var grid = $('.product-grid');
      if (grid) grid.classList.add('is-loading');
      window.location.search = params.toString();
    }
    form.addEventListener('change', function (e) {
      clearTimeout(timer);
      timer = setTimeout(submit, e.target.type === 'number' ? 700 : 50);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  });


  /* Product showcase: auto-slide + per-product photo cycling -------------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initShowcase(root) {
    if (root.dataset.showcaseReady) return;
    root.dataset.showcaseReady = '1';
    var track = $('[data-showcase-track]', root);
    var cards = $$('[data-showcase-card]', root);
    var dotsWrap = $('[data-showcase-dots]', root);
    if (!track || !cards.length) return;

    var speed = parseInt(root.dataset.speed, 10) || 4000;
    var imageSpeed = parseInt(root.dataset.imageSpeed, 10) || 4000;
    var autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
    var visible = false, paused = false, slideTimer = null;
    root.style.setProperty('--image-speed', imageSpeed + 'ms');

    function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    function maxIndex() { return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step())); }
    function currentIndex() { return Math.round(track.scrollLeft / step()); }
    function goTo(i) {
      var max = maxIndex();
      if (i > max) i = 0;
      if (i < 0) i = max;
      track.scrollTo({ left: i * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var count = maxIndex() + 1;
      if (count < 2) return;
      for (var i = 0; i < count; i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.tabIndex = -1; b.dataset.index = i;
        dotsWrap.appendChild(b);
      }
      syncDots();
    }
    function syncDots() {
      if (!dotsWrap) return;
      var idx = currentIndex();
      $$('button', dotsWrap).forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
    }
    if (dotsWrap) dotsWrap.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (b) { goTo(parseInt(b.dataset.index, 10)); restart(); }
    });

    var prev = $('[data-showcase-prev]', root), next = $('[data-showcase-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); restart(); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); restart(); });

    var scrollT;
    track.addEventListener('scroll', function () { clearTimeout(scrollT); scrollT = setTimeout(syncDots, 60); }, { passive: true });

    function tick() { if (visible && !paused) goTo(currentIndex() + 1); }
    function restart() {
      clearInterval(slideTimer);
      if (autoplay && maxIndex() > 0) slideTimer = setInterval(tick, speed);
    }
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, function () { paused = true; }, { passive: true }); });
    ['mouseleave', 'focusout', 'touchend'].forEach(function (ev) { root.addEventListener(ev, function () { paused = false; }, { passive: true }); });

    /* photo cycling inside each card */
    var cyclers = $$('[data-image-cycle]', root).map(function (media, cardIndex) {
      var imgs = $$('.showcase-card__img', media);
      var bars = $$('.showcase-card__progress i', media);
      if (imgs.length < 2) return null;
      media.classList.add('is-cycling');
      var state = { i: 0, timer: null, delay: 0 };
      function show(i) {
        imgs.forEach(function (img, n) { img.classList.toggle('is-active', n === i); });
        bars.forEach(function (bar, n) {
          bar.classList.remove('is-active');
          bar.classList.toggle('is-done', n < i);
        });
        if (bars[i]) { void bars[i].offsetWidth; bars[i].classList.add('is-active'); }
      }
      show(0);
      imgs.forEach(function (img) { if (img.loading === 'lazy') img.loading = 'eager'; });
      state.start = function () {
        if (state.timer || reduceMotion) return;
        state.timer = setTimeout(function run() {
          state.i = (state.i + 1) % imgs.length;
          show(state.i);
          state.timer = setTimeout(run, imageSpeed);
        }, imageSpeed + state.delay);
      };
      state.stop = function () { clearTimeout(state.timer); state.timer = null; };
      return state;
    }).filter(Boolean);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        cyclers.forEach(function (c) { visible ? c.start() : c.stop(); });
      }, { threshold: 0.25 }).observe(root);
    } else { visible = true; cyclers.forEach(function (c) { c.start(); }); }

    buildDots();
    restart();
    var resizeT;
    window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(function () { buildDots(); restart(); }, 200); });
  }
  $$('[data-showcase]').forEach(initShowcase);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-showcase]'); if (el) initShowcase(el);
  });

  /* Customer login: toggle password recovery ----------------------------- */
  var login = $('[data-login]');
  if (login) {
    var loginView = $('[data-login-view]', login);
    var recoverView = $('[data-recover-view]', login);
    function showRecover(show) {
      loginView.hidden = show;
      recoverView.hidden = !show;
    }
    if (window.location.hash === '#recover' || $('[data-recover-success]', login) || $('.form-error', recoverView)) showRecover(true);
    login.addEventListener('click', function (e) {
      if (e.target.closest('[data-show-recover]')) { e.preventDefault(); showRecover(true); }
      if (e.target.closest('[data-hide-recover]')) { e.preventDefault(); showRecover(false); }
    });
  }

  /* Customer addresses: country -> province ------------------------------ */
  $$('[data-address-country]').forEach(function (countrySelect) {
    var wrap = countrySelect.closest('[data-address-country-wrap]');
    var provinceSelect = $('[data-address-province]', wrap);
    var provinceWrap = $('[data-address-province-wrap]', wrap);

    if (countrySelect.dataset.default) countrySelect.value = countrySelect.dataset.default;
    if (!countrySelect.value) countrySelect.value = 'United States';

    function fill() {
      var opt = countrySelect.options[countrySelect.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse((opt && opt.dataset.provinces) || '[]'); } catch (err) {}
      provinceSelect.innerHTML = '';
      if (!provinces.length) { provinceWrap.hidden = true; return; }
      provinceWrap.hidden = false;
      provinces.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        provinceSelect.appendChild(o);
      });
      if (provinceSelect.dataset.default) provinceSelect.value = provinceSelect.dataset.default;
    }
    countrySelect.addEventListener('change', fill);
    fill();
  });

  $$('form[data-confirm]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.confirm(form.dataset.confirm)) e.preventDefault();
    });
  });

  /* Theme editor: keep drawer in sync ------------------------------------ */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) drawer = $('[data-cart-drawer]');
  });
})();
